import React, { useState, useRef, useEffect } from "react";

function SearchDropdown({ data, label, required, placeholder, searchKey = "name", onChange, className, defaultValue, value }) {
    // console.log(value, "value")
    const [query, setQuery] = useState("");
    const [selected, setSelected] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [error, setError] = useState(false);
    const dropdownRef = useRef(null);
    const [touched, setTouched] = useState(false); // Track if input is touched

    // Filter data dynamically using the dynamic key
    const filteredData = data?.filter((item) =>
        item?.[searchKey]?.toString().toLowerCase().includes(query.toLowerCase())
    );

    const handleSelect = (item) => {
        setSelected(item);
        setQuery(item?.[searchKey]); // Dynamically set the query value
        setError(false);
        setIsOpen(false);
        onChange(item);
    };

    const handleBlur = () => {
        if (touched && (!selected || selected?.[searchKey] !== query)) {
            const matched = data?.find(item => item?.[searchKey] === query);
            if (matched) {
                handleSelect(matched);
            } else {
                setError(true);
            }
        }

    };

    useEffect(() => {
        if (defaultValue) {
            setQuery(defaultValue);
        }
    }, [])

    useEffect(() => {
        if (value) {
            setSelected(value);
            setQuery(value?.[searchKey] || "");
        }
    }, [value, searchKey]);



    // Close dropdown when clicking outside
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //             setIsOpen(false);
    //             handleBlur();
    //         }
    //     };
    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [query, selected]);

    return (
        <div className="relative w-full" >
            <label className="block text-sm font-semibold text-black mb-2">
                {label} {required && <span className="text-red-500">*</span>}
            </label>

            {/* Input Field with Dropdown Toggle Button */}
            <div className="relative">
                {/* {console.log(query, "query")} */}
                <input
                    type="text"
                    className={`w-full border ${error ? "border-red-500" : "border-gray-200"} 
                            rounded-lg py-2 pl-3 pr-10 text-sm text-black shadow-sm transition-all 
                            placeholder:text-black focus:ring-0 focus:outline-none ${className ? className : ""}`}
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        setError(false);
                        setIsOpen(true); // Ensure dropdown opens when user types
                    }}
                    onClick={() => setIsOpen(true)} // Open dropdown when user clicks
                    onFocus={() => setTouched(true)}
                    // onBlur={handleBlur}
                    placeholder={placeholder || "Select an option"}
                />




                <button
                    type="button"
                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-indigo-600 transition"
                    onClick={() => setIsOpen((prev) => !prev)}
                >
                    <svg
                        className={`w-5 h-5 transition-transform duration-200 ${isOpen ? "rotate-180" : "rotate-0"}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </button>
            </div>

            {/* Error Message */}
            {error && touched && <p className="text-red-500 text-xs mt-1">Please select a valid option.</p>}

            {/* Dropdown Menu */}
            {isOpen && (
                <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 shadow-lg rounded-lg max-h-60 overflow-auto py-1 text-sm text-gray-900 transition-all opacity-100 scale-100">
                    {filteredData.length === 0 ? (
                        <li className="cursor-default select-none px-4 py-2 text-gray-500">No results found</li>
                    ) : (
                        filteredData.map((item) => (
                            <li
                                key={item.id}
                                className="cursor-pointer px-4 py-2  hover:text-blue-500 transition"
                                onClick={() => handleSelect(item)}
                            >
                                {item?.[searchKey]}
                            </li>
                        ))
                    )}
                </ul>
            )}
        </div>
    );
}

export default SearchDropdown;
